<app-checkout-payment-forms #checkoutPaymentFormsComponent></app-checkout-payment-forms>
<app-store-payment-pay *ngIf="showPaymentPay"></app-store-payment-pay>
